import { useEffect } from "react"
import { IBackgroundProps } from "../Background"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"

/* https://codepen.io/Rowno/pen/EVEgJb */
export interface IBackgroundFoldsProps {
   
}
const BackgroundFolds = ({section, ...props}: IBackgroundProps): JSX.Element => {
    useEffect(() => {
        addCSSClass(
            `background-folds`,
            `.landing-background-folds {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                animation: theme 21s linear infinite;    
                &:after,
                &:before {
                    content: '';
                    display: block;
                    position: fixed;
                    z-index: 2;
                    top: -30%;
                    width: 180%;
                    height: 180%;
                    background: rgba(0,0,0,0.05);
                    animation: background 90s linear infinite;
                }
                &:after {
                    left: 15vw;
                }
                &:before {
                    right: 15vw;
                    animation-delay: -30s;
                    animation-direction: reverse;
                }
            }
            @keyframes theme {
                0% {
                    background: #74C390;
                }
                
                16% {
                    background: #5DBDB6;
                }
                
                33% {
                    background: #59D4E1;
                }
                
                50% {
                    background: #51BCE8;
                }
                
                66% {
                    background: #FA5374;
                }    
                
                83% {
                    background: #E46653;
                }

                100% {
                    background: #74C390;
                }
            }

            @keyframes background {
                0% {
                    transform: rotate(0deg);
                }
                
                100% {
                    transform: rotate(360deg);
                }
            } `
        )
        return () => removeCSSClass("background-folds")
    },[])
    return <div className='landing-background-folds' />
}
export default BackgroundFolds